import { connect } from "react-redux";
import GiaHanNoPhaiThu from "components/CommonComponent/GiaHanNoPhaiThu";
import { getLichSuNoPhaiThu } from "actions/ChiTietHopDong";
import { postGiaHanNoPhaiThu } from "actions/GiaHanNoPhaiThu";

const mapStateToProps = (state) => ({
  chitiethopdong: state.chitiethopdong,
  giahannophaithu: state.giahannophaithu,
});

const mapDispatchToProps = (dispatch) => ({
  getLichSuNoPhaiThu: (dataSearch) => dispatch(getLichSuNoPhaiThu(dataSearch)),
  postGiaHanNoPhaiThu: (dataPost) => dispatch(postGiaHanNoPhaiThu(dataPost)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GiaHanNoPhaiThu);
